import { ButtonComponent } from '@syncfusion/ej2-react-buttons';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../redux/store';

import saveIcon from '../../../icons/common/save.png';
import closeIcon from '../../../icons/common/close.png';
import activeIcon from '../../../icons/common/active.png';
import inactiveIcon from '../../../icons/common/inactive.png';
import {
    getAccessMgmtEndPoint,
    getStoreWsUpdate,
    updateAccessReqEndPoint,
} from '../utils';
import {
    setActiveDirectoryData,
    setIsGridRefresh,
    setPreviewImage,
    setUploadedImage,
    setUserAccessData,
} from '../accessmgmtReducer';
import axios from 'axios';
import notify from '../../../services/toasterService';
import { setRowData, setRowId } from '../../grid/gridReducer';
import { formatDate } from '../../settings/utils';
import { DatePickerComponent } from '@syncfusion/ej2-react-calendars';
import { DropDownListComponent } from '@syncfusion/ej2-react-dropdowns';
import AddAccessManagementScreen from '../addScreen/addScreen';
import Resetpopup from './resetpopup';
import ViewOnlyForm, {
    HideForViewOnly,
    ViewOnlyAllowAction,
} from '../../common/ViewOnlyForm/ViewOnlyForm';
import useRLAdminView from '../../../hooks/useRLAdminView';

const UserGeneralPreview = () => {
    const [addScreen, setAddScreen] = useState(false);
    const [manageScreen, setManageScreen] = useState<boolean>(false);

    const [addScreenTabName, setAddScreenTabName] = useState(null);

    const dispatch = useDispatch();
    const [userGeneralInfo, setUserGenInfo] = useState<any>({});
    let [selectedEndDate, setSelectedEndDate] = useState<any>();
    const [showAdd, setShowAdd] = useState(true);
    const { isReadOnly } = useRLAdminView();

    const [showStore, setShowStore] = useState(false);
    /* Get selected data from Grid Reducer */
    const selRowData = useSelector(
        (state: RootState) => state.gridReducer.selectedRowData
    );

    const locationsDataList = useSelector(
        (state: RootState) => state.accessMgmtReducer.locatonsList
    );
    const rolesListData = useSelector(
        (state: RootState) => state.accessMgmtReducer.rolesList
    );

    let uploadedImageFile = useSelector(
        (state: RootState) => state.accessMgmtReducer.previewImage
    );
    const [selectFields, setSelectFields] = useState<any[]>([
        {
            roleId: '',
            reclaimCenterId: '',
        },
    ]);
    let dropDownListObject: any;
    const [storesList, setStoresList] = useState<any>([]);

    const [storeId, setStoreId] = useState<any>();

    const [updatedUserGeneralInfo, setUpdateduserGenInfo] = useState<any>([]);

    useEffect(() => {
        if (selRowData && selRowData?.length > 0) {
            const userData = { ...selRowData[0] };
            setUpdateduserGenInfo([{ ...userData }]);
            if (
                userData?.userType === 'Mobile' ||
                userData?.userType === 'mobile'
            ) {
                setUserGenInfo({
                    ...userData,
                    roleID:
                        userData?.userCompanyMapping?.length > 0
                            ? userData?.userCompanyMapping[0]?.roleId[0]
                            : '',
                });
            } else {
                setUserGenInfo(userData);
            }

            dispatch(setUploadedImage([]));
            if (
                selRowData[0].endDate !== undefined &&
                selRowData[0].endDate !== null &&
                selRowData[0].endDate !== ''
            ) {
                selectedEndDate = formatDate(new Date(selRowData[0].endDate));
                formatInput(selRowData[0].endDate);
            } else {
                setSelectedEndDate(undefined);
            }

            setStoreId(
                selRowData[0]?.store?.storeNumber +
                    ' - ' +
                    selRowData[0]?.store?.storeName
            );
        } else {
            setUserGenInfo({});
            setUpdateduserGenInfo([]);
        }
        setShowStore(false);
        setSelectFields([
            {
                roleId: '',
                reclaimCenterId: '',
            },
        ]);
    }, [selRowData]);

    const autoCompleteFields = {
        value: 'id',
        text: 'storeName',
    };
    const getStoreNamewithMainFrameCustomer = (e: any) => {
        getStoreList(e.text);
    };

    const getStoreList = (storeName?: any) => {
        if (storeName.length > 2) {
            const endpoint: any = getStoreWsUpdate(storeName);
            const result = axios.get(endpoint);
            result
                .then((data: any) => {
                    setStoresList(data.data.content);
                })
                .catch((error: any) => {
                    notify(error.message, 'error');
                });
        } else {
        }
    };

    /**
     * Changing status for Preview selected tabs
     * @param flag - true/false
     */
    const changeStatusForRowData = (flag: any) => {
        if (flag === false) {
            setUserGenInfo({ ...userGeneralInfo, activeForGrid: 'Inactive' });
        } else {
            setUserGenInfo({ ...userGeneralInfo, activeForGrid: 'Active' });
        }
    };

    const getSelectedStorebyId = (id: any) => {
        storesList.map((item: any) => {
            if (item.id === id) return item;
        });
    };
    /* Update Users WS Call */
    const updateUserGeneralTabApi = async (data: any) => {
        //   const token = sessionStorage.getItem('token');
        //  const token = UserService.getToken()
        const endPointURL = updateAccessReqEndPoint('Users');
        let store = getSelectedStorebyId(userGeneralInfo?.storeId);
        const userCompanyMapping: any[] = [];

        if (userGeneralInfo?.userCompanyMapping?.length > 0) {
            userGeneralInfo?.userCompanyMapping?.map((item: any) => {
                userCompanyMapping.push({
                    companyId: item?.company?.id,
                    roleId: item.roleId || [],
                    reclaimCenterId: item?.reclaimCenter?.id,
                });
            });
        }

        let body = {
            // userId: userGeneralInfo?.company

            firstname: userGeneralInfo?.firstname,
            lastname: userGeneralInfo?.lastName,
            company: userGeneralInfo?.company,
            jobTitle: userGeneralInfo?.jobTitle,
            username: userGeneralInfo?.username,
            roleId: userGeneralInfo?.roleId,
            reclaimCenterId: userGeneralInfo?.reclaimCenterId,
            endDate: userGeneralInfo?.endDate,

            email: userGeneralInfo?.email,
            phoneNumber: userGeneralInfo?.phoneNumber,
            fax: userGeneralInfo?.fax,
            language: userGeneralInfo?.language,
            timezone:
                userGeneralInfo?.timezone !== null &&
                userGeneralInfo?.timezone !== undefined
                    ? userGeneralInfo?.timezone
                    : 'en-us',
            countryId: userGeneralInfo?.country,
            stateId: userGeneralInfo?.stateId,
            city: userGeneralInfo?.city,
            street: userGeneralInfo?.street,

            password: userGeneralInfo?.password,
            storeId:
                userGeneralInfo?.storeId !== null &&
                userGeneralInfo?.storeId !== undefined
                    ? userGeneralInfo?.storeId
                    : userGeneralInfo?.storeId,
            userType: userGeneralInfo?.userType,
            userId: userGeneralInfo?.userId,
            id: userGeneralInfo?.id,
            status: userGeneralInfo?.activeForGrid,
            userCompanyMapping: [...userCompanyMapping],
            scanUser:
                userGeneralInfo?.scanUser !== undefined &&
                userGeneralInfo?.scanUser !== null
                    ? userGeneralInfo?.scanUser
                    : {},
        };

        if (uploadedImageFile.length > 0 && uploadedImageFile !== undefined) {
            Object.assign(body, { image: uploadedImageFile[0].base64 });
        } else {
            Object.assign(body, { image: userGeneralInfo?.image });
        }
        if (userGeneralInfo?.userType === 'External') {
            if (
                userGeneralInfo?.scanUser !== undefined &&
                userGeneralInfo?.scanUser !== null &&
                userGeneralInfo?.scanUser !== ''
            ) {
                Object.assign(body, {
                    scanUser: {
                        binMaxScanQty: userGeneralInfo?.scanUser?.binMaxScanQty,
                        boxMaxScanQty: userGeneralInfo?.scanUser?.boxMaxScanQty,
                        scanMaxQty: userGeneralInfo?.scanUser?.scanMaxQty,
                        canCloseBin: userGeneralInfo?.scanUser?.canCloseBin,
                        hourlyScanGoal:
                            userGeneralInfo?.scanUser?.hourlyScanGoal,
                        supervisorPassword:
                            userGeneralInfo?.scanUser?.supervisorPassword,
                        id: userGeneralInfo?.scanUser?.id,
                    },
                });
            } else {
                Object.assign(body, { scanUser: {} });
            }
        }
        //  await axios.post(endPointURL, body, { headers: { 'Authorization': `Bearer ${token}` } }).then(
        await axios
            .post(endPointURL, body)
            .then(
                // (res) => {
                //     notify('User updated successfully', 'success');
                //     getUsers('Users');
                //    // clearPreview();
                // }
                (res: any) => {
                    if (res.data.status !== 200) {
                        notify(res.data.message, 'error');
                    } else {
                        notify(res.data.message, 'success');
                        // getUsers('Users');
                        dispatch(setIsGridRefresh(true));
                        dispatch(setRowData([]));
                        dispatch(setRowId(null));
                    }
                    setTimeout(() => {
                        // dispatch(setRowData(res.data[0]));
                        dispatch(setPreviewImage([]));
                    }, 10);
                    // clearPreview();
                }
            )
            .catch((err) => {
                //console.log(err, 'Users');
                notify('Failed to update user', 'error');
            });
    };

    /* Get Users WS Call */
    const getUsers = async (fieldName: any) => {
        // const token = sessionStorage.getItem('token');
        // const token = UserService.getToken()
        const getEndPointUrl = getAccessMgmtEndPoint(fieldName);
        // await axios.get(getEndPointUrl, { headers: { 'Authorization': `Bearer ${token}` } }).then((res: { data: any; }) => {
        await axios
            .get(getEndPointUrl)
            .then((res: { data: any }) => {
                // res.data.forEach((element: any) => {
                //     element.companyName =
                //         element.userCompanyMapping?.length > 0
                //             ? element.userCompanyMapping[0]?.company
                //                   ?.companyName
                //             : '';
                //     if (element.userCompanyMapping?.length > 0) {
                //         element.roleID =
                //             element.userCompanyMapping[0]?.roleId[0] || '';
                //     }
                // });
                // dispatch(setUserAccessData(res.data));
                // const dataa = res.data.filter(
                //     (ele: any) => ele.id === userGeneralInfo?.id
                // );
                // setUserGenInfo(dataa);
                // setTimeout(() => {
                // dispatch(setRowData(dataa));
                // dispatch(setRowData([]));
                //     setUpdateduserGenInfo(userGeneralInfo);
                // }, 5);
            })
            .catch((err: any) => {
                //console.log(err);
                notify(
                    'Error! Unable to fetch data. Please try after sometime.',
                    'error'
                );
            });
    };

    const clearPreview = () => {
        dispatch(setRowData([]));
        dispatch(setUploadedImage([]));
    };

    /* Update fields data  */
    const userInfoFieldFocusOut = (e: any, key: any) => {
        if (key === 'endDate') {
            setUserGenInfo({ ...userGeneralInfo, [key]: e.value });
        } else {
            setUserGenInfo({ ...userGeneralInfo, [key]: e.value });
        }
    };

    /* General User Preview Tab */
    const userFieldsSelectFocusOut = (event: any, key: any) => {
        if (key === 'storeId') {
            setUserGenInfo({ ...userGeneralInfo, [key]: event.value });
            //setStoreId(0);
            //validateMobileUsers()
        } else {
            setUserGenInfo({ ...userGeneralInfo, [key]: event.target.value });
        }
    };

    const formatInput = (e: any) => {
        selectedEndDate = formatDate(new Date(e));
    };

    const updateStoreId = () => {
        //setShowStore(true);
        setStoreId(0);
    };
    /* General User Preview Tab */

    const handleRenderModal = (type: any, userId: any) => {
        localStorage.setItem('userId', userId);
        setAddScreen(true);
        setAddScreenTabName(type);
    };

    const handleRefresh = () => {
        // clearPreview();
        // getUsers('Users');
        dispatch(setIsGridRefresh(true));
        dispatch(setRowData([]));
        dispatch(setRowId(null));
    };

    const UserGeneralPreviewData = (data: any) => {
        return (
            <ViewOnlyForm>
                {addScreen && (
                    <AddAccessManagementScreen
                        addScreen={addScreen}
                        setAddScreen={setAddScreen}
                        tabName={addScreenTabName}
                    />
                )}

                {manageScreen && (
                    <AddAccessManagementScreen
                        addScreen={manageScreen}
                        setAddScreen={setManageScreen}
                        onRefresh={handleRefresh}
                        tabName={'Manage_Company'}
                    />
                )}

                <div className="row">
                    <div className="col-sm-12 px-0">
                        <div
                            className="col-sm-5 col-md-5 col-lg-5 pr-0 preview-Key"
                            style={{ paddingLeft: '8px' }}
                        >
                            User Type
                        </div>
                        <div className="col-sm-7 col-md-7 col-lg-7 p-0 preview-value ">
                            <p className="accMgmtFields">
                                {userGeneralInfo?.userType}
                            </p>
                        </div>
                    </div>
                </div>
                <hr className="previewScreenDevider mt-0 mb-1"></hr>
                <div className="row">
                    <div className="col-sm-12 px-0 pt-0">
                        <div
                            className="col-sm-5 col-md-5 col-lg-5 preview-Key "
                            style={{ padding: '7px' }}
                        >
                            First Name
                        </div>

                        <div className="col-sm-7 col-md-7 col-lg-7 p-0 preview-value ">
                            <input
                                type="text"
                                className="form-control boxShadow-None border-none cursor-pointer txtEditFieldFocus accMgmtFields boxShadow-None pl-0"
                                value={userGeneralInfo?.firstname}
                                onChange={(e: any) =>
                                    userInfoFieldFocusOut(e.target, 'firstname')
                                }
                                onBlur={(e: any) =>
                                    userInfoFieldFocusOut(e.target, 'firstname')
                                }
                                onKeyUp={(e: any) =>
                                    userInfoFieldFocusOut(e.target, 'firstname')
                                }
                            />
                            {/* <InlineInputEdit inputClassName="txtEditClassNameInput  "  text={selRowData && selRowData[0]?.firstname} labelClassName="txtEditClassName"
                            onFocusOut={(e) => userInfoFieldFocusOut(e, 'firstname')} labelPlaceHolder='---'/>  */}
                        </div>
                    </div>
                    <div className="col-sm-12 px-0 pt-4 ">
                        <div
                            className="col-sm-5 col-md-5 col-lg-5 preview-Key  "
                            style={{ padding: '8px' }}
                        >
                            Last Name
                        </div>
                        <div className="col-sm-7 col-md-7 col-lg-7 p-0 preview-value ">
                            <input
                                type="text"
                                className="form-control boxShadow-None border-none cursor-pointer txtEditFieldFocus accMgmtFields boxShadow-None pl-0 "
                                onChange={(e: any) =>
                                    userInfoFieldFocusOut(e.target, 'lastName')
                                }
                                value={userGeneralInfo?.lastName}
                                onBlur={(e: any) =>
                                    userInfoFieldFocusOut(e.target, 'lastName')
                                }
                                onKeyUp={(e: any) =>
                                    userInfoFieldFocusOut(e.target, 'lastName')
                                }
                            />
                            {/* <InlineInputEdit inputClassName="txtEditClassNameInput  "  text={selRowData && selRowData[0]?.lastName} labelClassName="txtEditClassName"
                        onFocusOut={(e) => userInfoFieldFocusOut(e, 'lastName')} labelPlaceHolder='---'/>  */}
                        </div>
                    </div>

                    {(userGeneralInfo?.userType === 'Mobile' ||
                        userGeneralInfo?.userType === 'mobile') && (
                        <div className="col-sm-12 px-0 pt-4 ">
                            <div
                                className="col-sm-5 col-md-5 col-lg-5 preview-Key  "
                                style={{ padding: '8px' }}
                            >
                                Company
                            </div>
                            <div className="col-sm-7 col-md-7 col-lg-7 p-0 preview-value ">
                                <p className="accMgmtFields mb-0 mt-1">
                                    {userGeneralInfo?.companyName || ''}
                                </p>
                            </div>
                        </div>
                    )}

                    {(userGeneralInfo?.userType === 'Mobile' ||
                        userGeneralInfo?.userType === 'mobile') && (
                        <div className="col-sm-12 px-0 pt-4 ">
                            <div
                                className="col-sm-5 col-md-5 col-lg-5 preview-Key  "
                                style={{ padding: '8px' }}
                            >
                                Role
                            </div>
                            <div className="col-sm-7 col-md-7 col-lg-7 p-0 preview-value ">
                                <p className="accMgmtFields mb-0 mt-1">
                                    {rolesListData.find(
                                        (item: any) =>
                                            item.id === userGeneralInfo?.roleID
                                    )?.roleName || ''}
                                </p>
                            </div>
                        </div>
                    )}

                    <div className="col-sm-12 px-0 pt-4 ">
                        <div
                            className="col-sm-5 col-md-5 col-lg-5 preview-Key  "
                            style={{ padding: '8px' }}
                        >
                            Job Title
                        </div>
                        <div className="col-sm-7 col-md-7 col-lg-7 p-0 preview-value ">
                            <input
                                type="text"
                                className="form-control boxShadow-None border-none cursor-pointer txtEditFieldFocus accMgmtFields boxShadow-None pl-0 "
                                value={userGeneralInfo?.jobTitle}
                                onChange={(e: any) =>
                                    userInfoFieldFocusOut(e.target, 'jobTitle')
                                }
                                onBlur={(e: any) =>
                                    userInfoFieldFocusOut(e.target, 'jobTitle')
                                }
                                onKeyUp={(e: any) =>
                                    userInfoFieldFocusOut(e.target, 'jobTitle')
                                }
                            />
                            {/* <InlineInputEdit inputClassName="txtEditClassNameInput  "  text={userGeneralInfo?.jobTitle} labelClassName="txtEditClassName"
                            onFocusOut={(e) => userInfoFieldFocusOut(e, 'jobTitle')} labelPlaceHolder='---'/>  */}
                        </div>
                    </div>
                    <div className="col-sm-12 px-0 pt-4 ">
                        <div
                            className="col-sm-5 col-md-5 col-lg-5 preview-Key  "
                            style={{ padding: '8px' }}
                        >
                            Username
                        </div>
                        <div className="col-sm-7 col-md-7 col-lg-7 p-0 preview-value ">
                            <p className="accMgmtFields mb-0 mt-1">
                                {userGeneralInfo?.username}
                            </p>
                        </div>
                    </div>

                    {userGeneralInfo?.userType === 'Mobile' ||
                    userGeneralInfo?.userType === 'mobile' ? (
                        <div className="col-sm-12 px-0 pt-4 ">
                            <div
                                className="col-sm-5 col-md-5 col-lg-5 preview-Key  "
                                style={{ padding: '8px' }}
                            >
                                Store
                            </div>
                            <div className="col-sm-7 col-md-7 col-lg-7 p-0 preview-value ">
                                {/* {storeId !== null && storeId !== undefined && storeId !== 0 ? <span className="col-sm-12 px-0 py-2">
                            <p className="moduleItem">
                            <span className="module-access-value">
                                {userGeneralInfo?.storeId}
                            </span>
                        </p>
                      </span> : ''} */}
                                {showStore ? (
                                    <DropDownListComponent
                                        allowFiltering={true}
                                        ref={(scope) => {
                                            dropDownListObject = scope;
                                        }}
                                        dataSource={storesList}
                                        filtering={getStoreNamewithMainFrameCustomer.bind(
                                            this
                                        )}
                                        fields={autoCompleteFields}
                                        change={(e: any) =>
                                            userFieldsSelectFocusOut(
                                                e,
                                                'storeId'
                                            )
                                        }
                                    />
                                ) : (
                                    <span
                                        className="module-access-value pointer accMgmtFields"
                                        onClick={() => setShowStore(true)}
                                        style={{
                                            fontSize: '12px',
                                            fontWeight: 100,
                                            padding: '8px 0px',
                                        }}
                                    >
                                        {storeId}
                                    </span>
                                )}
                            </div>
                        </div>
                    ) : (
                        <></>
                    )}

                    <ViewOnlyAllowAction>
                        {(userGeneralInfo?.userType === 'External' ||
                            userGeneralInfo?.userType === 'external') && (
                            <div
                                className="col-sm-12 px-0 pt-4 cursor-pointer"
                                style={{
                                    fontSize: 13,
                                    textDecoration: 'underline',
                                    color: '#636799',
                                }}
                                onClick={() => setManageScreen(true)}
                            >
                                Manage Company & Role Details
                            </div>
                        )}
                    </ViewOnlyAllowAction>

                   
                        <HideForViewOnly>
                            {userGeneralInfo?.userType === 'Mobile' ||
                            userGeneralInfo?.userType === 'External' ||
                            userGeneralInfo?.userType === 'mobile' ||
                            userGeneralInfo?.userType === 'external' ? (
                                <div className="col-sm-12 px-0 pt-4 ">
                                    <div
                                        className="col-sm-12 preview-Key  pt-1"
                                        style={{ padding: '8px' }}
                                    >
                                        <ButtonComponent
                                            cssClass="e-outline opt-btn-light float-right"
                                            onClick={(e) =>
                                                handleRenderModal(
                                                    'Reset',
                                                    userGeneralInfo?.userId
                                                )
                                            }
                                        >
                                            {/* <img src={saveIcon} alt="Reset Password" /> */}
                                            Reset Password
                                        </ButtonComponent>
                                    </div>
                                </div>
                            ) : (
                                <></>
                            )}
                        </HideForViewOnly>
                   
                </div>
            </ViewOnlyForm>
        );
    };

    /* Footer Preview  */
    const footerPreview = (data: any) => {
        return (
            <div className="col-sm-12 px-0 pt-4">
                <div className="col-sm-6 col-md-6 col-lg-5 preview-Key p-0">
                    <HideForViewOnly>
                         <ButtonComponent
                        cssClass="e-outline opt-btn-light float-left"
                        onClick={() => updateUserGeneralTabApi(data)}
                    >
                        <img src={saveIcon} alt="Save" />
                    </ButtonComponent>

                    <ButtonComponent
                        cssClass="e-outline opt-btn-light float-left ml-3"
                        onClick={() => clearPreview()}
                    >
                        <img src={closeIcon} alt="Close" />
                    </ButtonComponent>
                    </HideForViewOnly>
                   
                </div>
                <div className="col-sm-6 col-md-6 col-lg-7 preview-value pt-3" >
                    <ViewOnlyForm>
                        <p className="preview-status">
                        {data?.activeForGrid === 'Active' ||
                        data?.activeForGrid === 'active' ? (
                            <span>
                                <img
                                 height={17}
                                    src={activeIcon}
                                    alt="Status"
                                    onClick={() =>
                                        changeStatusForRowData(false)
                                    }
                                />
                                &nbsp; &nbsp; Active
                            </span>
                        ) : (
                            <span>
                                <img
                                height={17}
                                    src={inactiveIcon}
                                    alt="Status"
                                    onClick={() => changeStatusForRowData(true)}
                                />
                                &nbsp; &nbsp; Inactive
                            </span>
                        )}
                    </p>
                    </ViewOnlyForm>
                    
                </div>
            </div>
        );
    };

    return (
        <div>
            {/* {userGeneralInfo && userGeneralInfo?.length > 0 ? ( */}
            <div className="col-sm-12 user-preview-details px-4 py-3">
                <div className="col-sm-12 px-3 py-3">
                    {UserGeneralPreviewData(userGeneralInfo)}
                </div>
             
                    <div className="col-sm-12 px-0 pt-2 pb-4">
                        {footerPreview(userGeneralInfo)}
                    </div>
                
            </div>
            {/* ) : (
                ''
            )} */}
        </div>
    );
};

export default UserGeneralPreview;
